"use client"

// src/tokens/blurs.ts
var blurs = {
  sm: "4px",
  md: "8px",
  lg: "12px",
  xl: "16px",
  "2xl": "24px"
};

export {
  blurs
};
//# sourceMappingURL=chunk-63SXWKLC.mjs.map